import { render, staticRenderFns } from "./create-coupon.vue?vue&type=template&id=d8331160&scoped=true&"
import script from "./create-coupon.vue?vue&type=script&lang=js&"
export * from "./create-coupon.vue?vue&type=script&lang=js&"
import style0 from "./create-coupon.vue?vue&type=style&index=0&id=d8331160&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8331160",
  null
  
)

export default component.exports